import { render } from "./StatisticsFilters.vue?vue&type=template&id=3cc8f98f"
import script from "./StatisticsFilters.vue?vue&type=script&lang=js"
export * from "./StatisticsFilters.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Tiresias\\Tiresias Project\\UI.Tiresias\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/vue/components/Statistics/StatisticsFilters.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3cc8f98f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3cc8f98f', __exports__)) {
    api.reload('3cc8f98f', __exports__)
  }
  
  module.hot.accept("./StatisticsFilters.vue?vue&type=template&id=3cc8f98f", () => {
    api.rerender('3cc8f98f', render)
  })

}


export default __exports__